import NextKickOff from "../../../../football/rules/general/next-kickoff";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

/**
 * Arms the kickoff that follows a score or the start of the second half.
 *
 * Two flag-specific gates on top of the shared rule:
 *
 *  - kickoffs are opt-in, and configs saved before the key existed lack it
 *    entirely, so an absent key must leave the game with no kickoff;
 *  - a safety never produces a kickoff in flag football. The shared rule only
 *    skips turnovers and punts, because tackle football *does* free-kick after
 *    a safety. Flag instead hands the ball straight to the scoring team at
 *    `spots.safetyYardline` (see FlagSafety and SafetyFieldSetup), so a safety
 *    has to be excluded here for that behaviour to survive - it is also why
 *    the flag config defines no post-safety kickoff spot.
 */
export default class FlagNextKickOff extends NextKickOff {
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        if (!isKickoffEnabled(gameContext)) return false;
        if (ruleContext.isSafety) return false;

        return super.applicable(gameContext, ruleContext, eventConfiguration, {
            play,
            fragment
        });
    }
}
